import React from "react";
import { marqueeItems } from "../../data/resume";
import "./marquee.css";

const Row = ({ hidden }) => (
  <ul className="marquee__row" aria-hidden={hidden || undefined}>
    {marqueeItems.map((item) => (
      <li key={item} className="marquee__item">
        {item}
        <span className="marquee__sep" aria-hidden="true">
          ✦
        </span>
      </li>
    ))}
  </ul>
);

const Marquee = () => (
  <div className="marquee" aria-label="Technologies I work with">
    <div className="marquee__track">
      <Row />
      <Row hidden />
    </div>
  </div>
);

export default Marquee;
